<template lang="pug">
	div
		vue-json-pretty(:path="'payloadType'", :data="formatted")
</template>

<script>
import VueJsonPretty from "vue-json-pretty";

export default {
	name: "JsonPretty",
	props: ["code"],
	components: {
		VueJsonPretty
	},
	computed: {
		formatted: function() {
			return JSON.parse(this.code);
		}
	}
};
</script>
